/** File-type helpers for the Files section. */

export type FileKind = 'image' | 'pdf' | 'doc' | 'sheet' | 'slides' | 'video' | 'audio' | 'archive' | 'other';

export function fileTypeFromUrl(url: string | null | undefined): FileKind {
  if (!url) return 'other';
  const ext = url.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'svg'].includes(ext)) return 'image';
  if (ext === 'pdf') return 'pdf';
  if (['doc', 'docx', 'odt', 'rtf', 'txt'].includes(ext)) return 'doc';
  if (['xls', 'xlsx', 'csv', 'numbers'].includes(ext)) return 'sheet';
  if (['ppt', 'pptx', 'key'].includes(ext)) return 'slides';
  if (['mp4', 'mov', 'webm', 'm4v', 'avi'].includes(ext)) return 'video';
  if (['mp3', 'wav', 'm4a', 'flac', 'aac'].includes(ext)) return 'audio';
  if (['zip', 'tar', 'gz', '7z', 'rar'].includes(ext)) return 'archive';
  return 'other';
}

export function prettyFileLabel(kind: FileKind): string {
  switch (kind) {
    case 'pdf': return 'PDF';
    case 'doc': return 'DOC';
    case 'sheet': return 'XLS';
    case 'slides': return 'PPT';
    case 'image': return 'IMG';
    case 'video': return 'MP4';
    case 'audio': return 'MP3';
    case 'archive': return 'ZIP';
    default: return 'FILE';
  }
}
